import { Component, Input, OnInit } from '@angular/core';
import { DataSharingService } from '../../AuthGuard/DataSharingService';
import { PartnerService } from '../services/partner.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-patner-loan-statement',
  templateUrl: './patner-loan-statement.component.html',
  styleUrls: ['./patner-loan-statement.component.scss']
})
export class PatnerLoanStatementComponent implements OnInit {
  @Input() loanSummary: any;      // customer loan summary (may contain partner loan ID)
  @Input() PageType: any;

  showSpinner: boolean = false;
  tab: string = 'clist';

  PLoanSummary: any = null;       // will hold partner data after fetch
  PLoanType: string = 'Partner';
  FirstEMIDate: any = null;
  isPartnerPortal: boolean = false;

  constructor(
    private dataSharingService: DataSharingService,
    private partnerService: PartnerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next('Loan Statement');
    
    this.isPartnerPortal = this.router.url.toLowerCase().includes('/partner-dashboard/');

    // Set default tab based on URL
    if (this.isPartnerPortal) {
      this.tab = ''; // Reset to ensure changeTabList runs
      this.changeTabList('plist');
    } else {
      this.tab = 'clist';
    }
  }

  changeTabList(tab: string) {
    if (this.tab === tab) return;
    this.tab = tab;

    if (tab === 'plist') {
      // Only fetch if we don't already have the data
      if (!this.PLoanSummary && this.loanSummary) {
        // Use the correct partner loan ID – check which property exists
        const partnerLoanId = this.loanSummary.LoanId;
        if (!partnerLoanId) {
          console.error('No partner loan ID found in loanSummary', this.loanSummary);
          return;
        }

        this.showSpinner = true;
        this.partnerService.Partner_Get_Loan_Details({ LoanId: partnerLoanId })
          .subscribe({
            next: (res: any) => {
              console.log('Partner API response:', res); // DEBUG
              if (res && res.Item1 && res.Item1.length) {
                this.PLoanSummary = {
                  LoanNo: res.Item1[0].PLoanAcNo,
                  LoanDate: res.Item1[0].PLoan_Date,
                  LoanAmount: res.Item1[0].NetFinance,
                  LoanId: partnerLoanId,
                  ApplicationNo: this.loanSummary.ApplicationNo,
                };
                this.FirstEMIDate = res.Item1[0].FirstEMIDate;
              } else {
                console.error('Partner API returned empty data');
                this.PLoanSummary = null;
              }
              this.showSpinner = false;
            },
            error: (err) => {
              console.error('Partner API error:', err);
              this.showSpinner = false;
            }
          });
      }
    }
    // For customer tab, nothing to load – data is already in this.loanSummary
  }
}